var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v("We couldn't find this page for you...")])])
}]

export { render, staticRenderFns }